import React from "react";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="apr-footer" aria-labelledby="footer-heading">
      {/* Subtle glow + particles */}
      <div className="apr-footer__bg">
        <div className="apr-footer__particles" aria-hidden="true">
          {[...Array(12)].map((_, i) => (
            <span
              key={i}
              className="apr-footer__particle"
              style={{
                "--size": `${Math.random() * 4 + 2}px`,
                "--x": `${Math.random() * 100}%`,
                "--y": `${Math.random() * 100}%`,
                "--delay": `${Math.random() * 5}s`,
                "--duration": `${Math.random() * 10 + 10}s`,
              }}
            />
          ))}
        </div>
      </div>

      <div className="apr-footer__container">
        {/* Main 3-column grid */}
        <div className="apr-footer__main">
          {/* Brand */}
          <section className="apr-footer__brand" aria-labelledby="footer-heading">
            <h2 id="footer-heading" className="apr-footer__brand-title">
              A Peaceful Retreat
            </h2>
            <p className="apr-footer__brand-text">
              Your sanctuary for therapeutic massage and holistic wellness.
              Experience the perfect balance of mind, body, and spirit.
            </p>
            <div className="apr-footer__brand-ornament" aria-hidden="true">
              <span className="apr-footer__ornament-line" />
              <span className="apr-footer__ornament-dot" />
              <span className="apr-footer__ornament-line" />
            </div>
          </section>

          {/* Explore */}
          <nav className="apr-footer__nav" aria-label="Explore">
            <h3 className="apr-footer__section-title">
              <span className="apr-footer__title-accent">Explore</span>
            </h3>
            <ul className="apr-footer__nav-list">
              <li><a href="/" className="apr-footer__link">Home</a></li>
              <li><a href="/services" className="apr-footer__link">Services</a></li>
              <li><a href="/about" className="apr-footer__link">About Us</a></li>
              <li><a href="https://mysite.vagaro.com/apeacefulretreat" className="apr-footer__link">Contact</a></li>
            </ul>
          </nav>

          {/* Connect */}
          <section className="apr-footer__contact" aria-label="Connect">
            <h3 className="apr-footer__section-title">
              <span className="apr-footer__title-accent">Connect</span>
            </h3>

            <address className="apr-footer__address">
              <div className="apr-footer__address-line">United States —</div>
              <div className="apr-footer__address-line">5511 112th Ave E, Suite B</div>
              <div className="apr-footer__address-line">Puyallup, WA 98372</div>
            </address>

            <a className="apr-footer__contact-row" href="mailto:info@apeacefulretreat.com">
              <span className="apr-footer__contact-icon" aria-hidden="true">✉</span>
              <span className="apr-footer__contact-text">info@apeacefulretreat.com</span>
            </a>

            <a className="apr-footer__contact-row" href="tel:+17708767485">
              <span className="apr-footer__contact-icon" aria-hidden="true">📞</span>
              <span className="apr-footer__contact-text">+1 (770) 876-7485</span>
            </a>
          </section>
        </div>

        {/* Payment Methods Section */}
        <div className="apr-footer__payment">
          <h3 className="apr-footer__section-title">
            <span className="apr-footer__title-accent">Accepted Payments</span>
          </h3>
          <div className="apr-footer__payment-methods">
            <span className="apr-footer__payment-text">Cash</span>
            <span className="apr-footer__payment-separator" aria-hidden="true">|</span>
            <span className="apr-footer__payment-text">Card</span>
            <span className="apr-footer__payment-separator" aria-hidden="true">|</span>
            <span className="apr-footer__payment-text">FSA</span>
            <span className="apr-footer__payment-separator" aria-hidden="true">|</span>
            <span className="apr-footer__payment-text">HSA</span>
          </div>
        </div>
      </div>

      {/* Bottom bar with legal links */}
      <div className="apr-footer__bottom">
        <div className="apr-footer__container">
          <div className="apr-footer__bottom-content">
            <div className="apr-footer__copyright">
              <span className="apr-footer__brand-small">A Peaceful Retreat</span>
              <span>© {year}. All Rights Reserved.</span>
            </div>
            
            <div className="apr-footer__legal-links">
              <a href="/terms" className="apr-footer__legal-link">Terms & Conditions</a>
              <span className="apr-footer__legal-separator" aria-hidden="true">•</span>
              <a href="/privacy" className="apr-footer__legal-link">Privacy Policy</a>
              <span className="apr-footer__legal-separator" aria-hidden="true">•</span>
              <a href="https://connectrader.com/" className="apr-footer__legal-link">Site by connectrader</a>
            </div>
            
            <span className="apr-footer__bottom-ornament" aria-hidden="true" />
          </div>
        </div>
      </div>
    </footer>
  );
}